// @flow
import * as React from 'react';
import type { TriedItItemType } from 'app/common/react/components/do/aggregated-pins/did-it/common/DidItFeedItem';
import { Image, Mask } from 'gestalt';

type Props = {
  item: TriedItItemType,
};

export default function TriedItPhoto(props: Props) {
  const {
    item: { images, pin },
  } = props;

  const hasImage = images.length > 0;
  const tryImage = hasImage ? images[0]['750x'] : null;
  if (!hasImage || !tryImage) {
    return null;
  }

  const triedItImageURL = images[0]['750x'].url;
  return (
    <Mask shape="rounded" wash>
      <Image
        alt={pin.title}
        src={triedItImageURL}
        key={triedItImageURL}
        color="#efefef"
        naturalWidth={tryImage.width}
        naturalHeight={tryImage.height}
      />
    </Mask>
  );
}
